import {
  createLpCompanyRevaluationsRoute,
  LP_CAPITAL_ACTION_CREATE,
  LP_INVESTMENT_CREATE,
} from 'adminConstants/routes';
import SuccessPage from 'components/new/SuccessPage';
import { FundingSource } from 'further-types/lp/investment';
import { useParams } from 'react-router-dom';

const InvestmentSuccess: React.FC = () => {
  const { assetId, fundingSource, showRevaluation } = useParams<{
    assetId?: string;
    fundingSource?: FundingSource;
    showRevaluation?: string;
  }>();

  const shouldShowRevaluationInfo = showRevaluation === 'true';

  return (
    <SuccessPage
      title="Investment has been created successfully"
      content={
        fundingSource === FundingSource.GeneralCapitalOnAccounts
          ? `The General Ledger has been updated and this investment has been allocated from available general capital. ${
              shouldShowRevaluationInfo
                ? 'If you wish to revalue the full investment asset, you can do so below.'
                : ''
            }`
          : `The General Ledger has been updated and this investment will be available to add into the next capital call. ${
              shouldShowRevaluationInfo
                ? 'If you wish to revalue the full investment asset, you can do so below.'
                : ''
            }`
      }
      primaryButton={{
        label: 'Process capital call',
        link: LP_CAPITAL_ACTION_CREATE,
      }}
      secondaryButton={
        shouldShowRevaluationInfo
          ? {
              label: 'Revalue full investment asset',
              link: createLpCompanyRevaluationsRoute(assetId ?? ''),
            }
          : undefined
      }
      tertiaryButton={{
        label: 'Add another investment',
        link: LP_INVESTMENT_CREATE,
      }}
      buttonsLayout="row"
    />
  );
};

export default InvestmentSuccess;
